import { render, staticRenderFns } from "./ChecklistItemClassTable.vue?vue&type=template&id=57f6be65&scoped=true"
import script from "./ChecklistItemClassTable.vue?vue&type=script&lang=js"
export * from "./ChecklistItemClassTable.vue?vue&type=script&lang=js"
import style0 from "./ChecklistItemClassTable.vue?vue&type=style&index=0&id=57f6be65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6be65",
  null
  
)

export default component.exports